// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"logo-adobe-lightroom"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M3 3L21 3L21 21L3 21L3 3Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M3 3L21 3L21 21L3 21L3 3Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M15 12V17M7 7L7 17C8.66667 17 12 17 12 17M19 12.5C17.7194 12.5 16.4913 13.0087 15.5858 13.9142L15.4393 14.0607","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const LogoAdobeLightroomIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'logo-adobe-lightroom',
    ref,
    icon: element,
  },
));

LogoAdobeLightroomIcon.displayName = 'LogoAdobeLightroomIcon';

export default LogoAdobeLightroomIcon;
